/* eslint-disable sort-keys-fix/sort-keys-fix */
// NOTE: name should be lowercase as lowercase serializer is used.
export const REPORTS_ROUTE = {
  name: 'reports',
  route(): string[] {
    return ['/' + this.name];
  },
  TEACHER_REGISTRATION_FUNNEL_COHORT: {
    name: 'teacherregistrationfunnelcohort',
    route(): string[] {
      return [...REPORTS_ROUTE.route(), this.name];
    }
  },
  STUDENT_ACTIVITY_RETENTION: {
    name: 'studentretention',
    route(): string[] {
      return [...REPORTS_ROUTE.route(), this.name];
    }
  },
  PARENT_CHEERS_ACTIVITY_RETENTION: {
    name: 'parentretention',
    route(): string[] {
      return [...REPORTS_ROUTE.route(), this.name];
    }
  },
};
